/**
 * @fileoverview POST handler for the "/:app_group_id/conversational/test_webhook" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { conversationalTestWebhookCacheKeys } from "./constants";
import type {
  PostConversationalTestWebhookErrors,
  PostConversationalTestWebhookProps,
  PostConversationalTestWebhookResult,
} from "./types";

export const postConversationalTestWebhook = reactQueryMutationAdapter(
  conversationalTestWebhookCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostConversationalTestWebhookErrors>()(
    (props: PostConversationalTestWebhookProps): Promise<PostConversationalTestWebhookResult> => {
      return fetch(
        `/${props.appGroupId}/conversational/test_webhook`,
        "POST",
        {
          description: props.description,
          request_method: props.requestMethod,
          url: props.url,
          body: props.body,
          headers: props.headers,
          credential_id: props.credentialId,
          variables: props.variables,
          response_fields: props.responseFields,
          variable_values: props.variableValues,
        },
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
